import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Ship, Loader2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    const res = await login(email, password);
    setBusy(false);
    if (!res.ok) return setError(res.error);
    nav(res.user.role === "customer" ? "/portal" : "/panel");
  };

  return (
    <div className="grid min-h-screen lg:grid-cols-2">
      <div className="flex items-center justify-start bg-white px-6 py-16 sm:px-12 lg:px-16">
        <div className="w-full max-w-md animate-fade-up">
          <div className="mb-10 flex items-center gap-2">
            <Ship className="h-6 w-6 text-klein" strokeWidth={2.5} />
            <span className="font-display text-lg font-black tracking-tighter">
              SEVER<span className="text-klein">GATE</span>
            </span>
          </div>
          <p className="overline">Operasyon Merkezi</p>
          <h1 className="mt-2 font-display text-4xl font-black tracking-tighter text-zinc-950 sm:text-5xl">
            Sisteme Giriş
          </h1>
          <p className="mt-3 max-w-sm text-sm text-zinc-600">
            Talep, teklif, operasyon dosyası, evrak ve kârlılık takibi tek ekranda.
          </p>

          <form onSubmit={submit} className="mt-10 space-y-5" data-testid="login-form">
            <div>
              <label className="overline">E-posta</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="ad.soyad@sirket.com"
                className="brut-input mt-1.5"
                data-testid="login-email-input"
              />
            </div>
            <div>
              <label className="overline">Şifre</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                className="brut-input mt-1.5"
                data-testid="login-password-input"
              />
            </div>
            {error && (
              <p className="border border-red-200 bg-red-50 px-3 py-2 text-sm text-red-700" data-testid="login-error">
                {error}
              </p>
            )}
            <button type="submit" disabled={busy} className="brut-btn w-full" data-testid="login-submit-button">
              {busy && <Loader2 className="h-4 w-4 animate-spin" />} Giriş Yap
            </button>
          </form>
        </div>
      </div>
      <div className="relative hidden lg:block">
        <img
          src="https://images.unsplash.com/photo-1568347877321-f8935c7dc5a3?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400"
          alt="Konteyner gemisi"
          className="h-full w-full object-cover"
        />
        <div className="absolute bottom-0 left-0 right-0 border-t border-zinc-950 bg-white px-8 py-5">
          <p className="overline">Kara · Deniz · Hava</p>
          <p className="mt-1 font-display text-xl font-bold tracking-tight">
            Severgate Logistics · Uçtan uca operasyon kontrolü
          </p>
        </div>
      </div>
    </div>
  );
}
